export const STATEMENTS_ROUTE = 'oświadczenia';
